import { render, staticRenderFns } from "./spikePart2Item.vue?vue&type=template&id=f3cbfa1e&scoped=true&"
import script from "./spikePart2Item.vue?vue&type=script&lang=ts&"
export * from "./spikePart2Item.vue?vue&type=script&lang=ts&"
import style0 from "./spikePart2Item.vue?vue&type=style&index=0&id=f3cbfa1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3cbfa1e",
  null
  
)

export default component.exports